import React, { Component } from "react";
import HeroSection from "./hero-section";
import MissionSection from "./mission-section";
import CompanySection from "./company-section";
import IndustriesSection from "./our-industries-section";
import ClientSection from "./clients-section";
import CtaSection from "../cta/cta-section";

class Home extends Component {
  render() {
    return (
      <React.Fragment>
        <HeroSection />
        <MissionSection />
        <CompanySection />
        <IndustriesSection />
        <ClientSection />
        <CtaSection />
      </React.Fragment>
    );
  }
}

export default Home;
